import { Controller } from '@hotwired/stimulus'
import { Chart, registerables } from 'chart.js'

// Регистрируем все компоненты Chart.js
Chart.register(...registerables)

export default class extends Controller {
  static values = {
    data: Object,
    type: { type: String, default: 'line' },
    options: { type: Object, default: {} }
  }

  connect() {
    this.createChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  createChart() {
    const ctx = this.element.getContext('2d')
    const defaultOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'top',
          labels: {
            usePointStyle: true,
            padding: 15,
            font: {
              size: 12
            }
          }
        },
        tooltip: {
          mode: 'index',
          intersect: false,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          padding: 12,
          titleFont: {
            size: 14
          },
          bodyFont: {
            size: 12
          }
        }
      },
      scales: {
        x: {
          display: true,
          title: {
            display: true,
            text: 'Дата прохождения',
            font: {
              size: 12,
              weight: 'bold'
            }
          },
          grid: {
            display: true,
            color: 'rgba(0, 0, 0, 0.05)'
          }
        },
        y: {
          display: true,
          title: {
            display: true,
            text: 'Балл',
            font: {
              size: 12,
              weight: 'bold'
            }
          },
          beginAtZero: true,
          grid: {
            display: true,
            color: 'rgba(0, 0, 0, 0.05)'
          }
        }
      },
      interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false
      }
    }

    const mergedOptions = { ...defaultOptions, ...this.optionsValue }

    this.chart = new Chart(ctx, {
      type: this.typeValue,
      data: this.dataValue,
      options: mergedOptions
    })
  }
}
